module.exports = __webpack_public_path__ + "img/35.e6fdb838.jpg";